import { useNavigate } from "react-router-dom";
import { useSendOtpMutation } from "../State/Api/LoginApiSlice";
import { useFormik } from "formik";
import * as Yup from "yup";

function ForgotPassword() {

    const navigate = useNavigate();

    const [sendOtp] = useSendOtpMutation();

    const formik = useFormik({
        initialValues: {
            email: ""
        },
        validationSchema: Yup.object({
            email: Yup.string()
                .email("Invalid email address")
                .required("Email is required"),
        }),
        onSubmit: async (values) => {
           try{
             const result = await sendOtp(values.email).unwrap();
            navigate("/otp", { state: { email: values.email } });
           }catch(error){
         
           }
        }
    });

    return (
        <>
            <section className="section-bg" style={{ width: '100%', height: "100%", display: "flex", position: "relative" }}>
                <div className="div-totLg0piuG">
                    <form onSubmit={formik.handleSubmit} className="form-ym5zR5QPwa rounded-4">

                        <div className="d-flex flex-column align-items-center justify-content-center mb-4">
                        <h4 className="fw-bold mb-4">Forgot Password</h4>
                        <span className="">Enter your email address, to receive an OTP to reset your password.</span>
                        </div>

                        <hr className="mb-4" />

                        <div className="div-sxjsnjij9 mb-3">
                            <label htmlFor="" className="form-label fw-semibold" style={{ fontSize: "14px" }}>Email Address</label>
                            <input name="email" value={formik.values.email} onChange={formik.handleChange} onBlur={formik.handleBlur} className="form-control" type="text" placeholder="Email Address" style={{ width: "100%", height: "2.5rem" }} />
                            {formik.touched.email && formik.errors.email ? <div className="text-danger">{formik.errors.email}</div> : null}
                        </div>

                        {/* <div className=" div-sxjsnjij9 mb-3 position-relative">
                            <label htmlFor="" className="form-label fw-semibold" style={{ fontSize: "14px" }}>Confirm New Password</label>
                            <input className="form-control" type="password" placeholder="Password" style={{ width: "100%", height: "2.5rem" }} />
                            <div className="position-absolute" style={{ top: "38px", right: "4px" }}>
                                <button style={{ background: "none" }} className="d-flex align-items-center justify-content-center border-0"><i class="material-icons" style={{ fontSize: '1.5rem', color: "#ababab" }}>visibility</i></button>
                            </div>
                        </div> */}


                        <button
  className="border-0 rounded-2 d-flex align-items-center justify-content-center"
  type="submit"
  disabled={formik.isSubmitting}
  style={{
    width: '100%',
    background: "#367588",
    color: '#fff',
    padding: ".5rem .5rem",
    opacity: formik.isSubmitting ? 0.7 : 1,
    cursor: formik.isSubmitting ? 'not-allowed' : 'pointer',
  }}
>
  {formik.isSubmitting ? (
    <>
      <span
        className="spinner-border spinner-border-sm me-2"
        role="status"
        aria-hidden="true"
      ></span>
      Sending OTP...
    </>
  ) : (
    "Get OTP"
  )}
</button>


                    </form>
                </div>

                <div className="img-V6fpDDVfc2">
                    <img src="/Images/BG_SignIn.png" alt="" />
                </div>
            </section>
        </>
    )
}

export default ForgotPassword